// "https://edna.dte/files?name=file.pdf"
export const getNameByUrl = (stringUrl?: string) => {
  if (!stringUrl || !stringUrl.match('/files?')) {
    return undefined;
  }
  const url = new URL(stringUrl);

  return url.searchParams.get('name') ?? undefined;
};
